import React, { ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";

type ErrorFallbackProps = {
  children: ReactNode | ReactNode[];
};

interface FallbackProps {
  error: Error;
  resetErrorBoundary: (...args: Array<unknown>) => void;
}

function Fallback({ error, resetErrorBoundary }: FallbackProps) {
  const { t } = useTranslation();
  return (
    <>
      <div role="alert">
        <p> {t("core.ErrorFallback.labels.somethingWentWrong")}</p>
        <pre>{error.message}</pre>
        <button onClick={resetErrorBoundary}>{t(
          "core.ErrorFallback.labels.somethingWentWrong"
        )}</button>
      </div>
    </>
  );
}

const myErrorHandler = (error: Error, info: { componentStack: string }) => {
  console.log("Error from error boundary ", error);
  console.log("Error info from error boundary ", info);
};

const ErrorFallback: React.FC<any> = ({ children }: ErrorFallbackProps) => {
  return (
    <ErrorBoundary FallbackComponent={Fallback} onError={myErrorHandler}>
      {children}
    </ErrorBoundary>
  );
};

export default ErrorFallback;